const API_KEY = process.env.REACT_APP_GEMINI_API_KEY;

export async function findRecipes(ingredients, existingRecipeNames = [], onStatusChange = () => {}) {
  onStatusChange("Creating a prompt for searching recipes using provided ingredients...");
  let prompt = `Find easy-to-make recipes using one, a few, or all of the following ingredients: ${ingredients}. The recipes should take no more than 15 minutes of preparation time. Ensure you provide at least one recipe for each category (breakfast, lunch, dinner, snacks).`;

  if (existingRecipeNames.length > 0) {
    prompt += ` Do not suggest recipes that are similar to these existing recipes: ${existingRecipeNames.join(', ')}.`;
  }

  prompt += ` Return the recipes as a JSON array of objects, where each object has an "id", a "name", a "category" (must be strictly one of: "breakfast", "lunch", "dinner", or "snacks"), and a "full" property. The "full" property should contain the full recipe with ingredients and instructions.`;

  onStatusChange("Searching the recipes...");
  const response = await fetch(`https://aiplatform.googleapis.com/v1/publishers/google/models/gemini-2.5-flash-lite:generateContent?key=${API_KEY}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      contents: [{
        role: 'user',
        parts: [{
          text: prompt,
        }],
      }],
    }),
  });

  if (!response.ok) {
    const errorBody = await response.text();
    throw new Error(`Failed to find recipes. Status: ${response.status}. Body: ${errorBody}`);
  }

  onStatusChange("Found the recipes! Processing data...");
  const data = await response.json();
  console.log('Gemini API Response:', JSON.stringify(data, null, 2));
  let recipesText = data.candidates[0].content.parts[0].text;

  // The response might be wrapped in markdown backticks, so we clean it up.
  if (recipesText.startsWith('```json')) {
    recipesText = recipesText.substring(7, recipesText.length - 3);
  }

  try {
    const parsedData = JSON.parse(recipesText);
    const recipesList = Array.isArray(parsedData) ? parsedData : (parsedData.recipes || []);
    // Add a placeholder for the full recipe if it's not provided
    return recipesList.map(recipe => ({
      ...recipe,
      category: ['breakfast', 'lunch', 'dinner', 'snacks', 'snack'].includes(recipe.category?.toLowerCase()) 
        ? (recipe.category.toLowerCase() === 'snack' ? 'snacks' : recipe.category.toLowerCase())
        : 'dinner',
      full: recipe.full || 'Full recipe placeholder...',
    }));
  } catch (e) {
    console.error("Failed to parse recipes JSON, assuming it's a conversational message:", e);
    // If we can't parse it as JSON, the LLM probably gave us a text response.
    return { error: true, message: recipesText };
  }
}
